module.exports = __webpack_public_path__ + "07_hair_black.550f202d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer5/07_hair_black.png
// module id = s6HU
// module chunks = 0